import service from './service';
import serviceTwo from './serviceTwo';

export const broadcastALert = async (data) => {
  try {
    const response = await service.post(`/emergencies`, data);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const notifyFriends = async (data) => {
  try {
    const response = await serviceTwo.postTwo(`/broadcast/notify-friends`, data);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};
